"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./verifySingleSkill.scss");
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const StyledVerifySingleSkill = styled_components_1.default.div `
  background: ${(props) => `${props.primaryColor}33`} !important;

  .skill-title{
    color: ${(props) => props.primaryColor} !important;
  }

  .skill-title-disabled{
    color: ${(props) => `${props.primaryColor}`} !important;
`;
function VerifySingleSkill(props) {
    const config = (0, master_1.getMasterConfig)();
    return !props.skillPageLink ? (react_1.default.createElement(StyledVerifySingleSkill, { primaryColor: config.primaryColor, className: "verify-single-skill half-opacity" },
        react_1.default.createElement("span", { className: "skill-title-disabled" }, props.skillTitle))) : (react_1.default.createElement(StyledVerifySingleSkill, { primaryColor: config.primaryColor, className: "verify-single-skill crs-pnt", onClick: () => {
            props.navigateToSkillPage(props.skillId.toString());
        } },
        react_1.default.createElement("span", { className: "skill-title" }, props.skillTitle)));
}
exports.default = VerifySingleSkill;
